import { db } from '../firebase';
import { collection, addDoc, doc, getDoc, getDocs, updateDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { COLLECTION_GUILDS, SOURCE_SYSTEM, SCHEMA_VERSION } from '../shared/constants';

export async function createGuild(guildData) {
    try {
        const docRef = await addDoc(collection(db, COLLECTION_GUILDS), {
            ...guildData,
            sourceSystem: SOURCE_SYSTEM,
            schemaVersion: SCHEMA_VERSION,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp(),
        });
        return { success: true, id: docRef.id };
    } catch (error) {
        console.error('Error creating guild:', error);
        throw error;
    }
}

export async function getAllGuilds() {
    try {
        const querySnapshot = await getDocs(collection(db, COLLECTION_GUILDS));
        return querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
        }));
    } catch (error) {
        console.error('Error getting guilds:', error);
        throw error;
    }
}

export async function getGuildById(id) {
    try {
        const docRef = doc(db, COLLECTION_GUILDS, id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return { id: docSnap.id, ...docSnap.data() };
        }
        return null;
    } catch (error) {
        console.error('Error getting guild:', error);
        throw error;
    }
}

export async function updateGuild(id, updates) {
    try {
        const docRef = doc(db, COLLECTION_GUILDS, id);
        await updateDoc(docRef, {
            ...updates,
            updatedAt: serverTimestamp(),
        });
        return { success: true };
    } catch (error) {
        console.error('Error updating guild:', error);
        throw error;
    }
}

export async function deleteGuild(id) {
    try {
        await deleteDoc(doc(db, COLLECTION_GUILDS, id));
        return { success: true };
    } catch (error) {
        console.error('Error deleting guild:', error);
        throw error;
    }
}
